var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-6",attrs:{"disabled":_vm.$attrs.disabled,"block":"","outlined":"","color":"primary","elevation":"3","rounded":"","large":""},on:{"click":_vm.callback}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }